import Btn from "@/components/common/Btn";
import Input from "@/components/common/Input";
import { useStore } from "@/store/index";
import { getUserCoupon } from "@/store/user/selectors-user";
import useAddCoupon from "@/utils/queries/hooks/useAddCoupon";
import { MDBCol, MDBRow } from "mdb-react-ui-kit";
import { useState } from "react";

const AddCouponForm = () => {
    const [coupon, setCoupon] = useState("");
    const couponSaved = useStore(state => getUserCoupon(state, coupon));
    const dispatchCommon = useStore(state => state.dispatchCommon);
    const setErrorMsg = useStore(state => state.setErrorMsg);

    const { mutate: saveCoupon } = useAddCoupon(coupon, () => setCoupon(""));

    const onSaveCoupon = () => {
        if (!couponSaved) {
            dispatchCommon({ type: "SET_LOADER_PAGE", payload: true });

            saveCoupon(coupon);
            return;
        }
        setErrorMsg({ message: "Coupon already exists" });
    };

    return (
        <MDBRow>
            <MDBCol size={9} lg={6} className="mt-2">
                <Input
                    type="text"
                    columnProps={{
                        size: 12,
                        className: "mb-xl-0 mb-3",
                    }}
                    label="Add coupon"
                    required
                    name="coupon"
                    id="coupon"
                    value={coupon}
                    onChange={e => setCoupon(e.target.value)}
                    diasbleStatusIcon
                />
                <Btn
                    onClick={onSaveCoupon}
                    className="my-3"
                    disabled={!coupon?.trim()}
                >
                    Save
                </Btn>
            </MDBCol>
        </MDBRow>
    );
};

export default AddCouponForm;
